var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSilverMedal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_97_5259)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6188 13.4218L12.2254 14.3493L8.96299 20L8.02661 17.9117L10.6188 13.4218Z",
    fill: "#418ED6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6189 13.4218L9.01229 12.4943L5.74988 18.145L8.02662 17.9117L10.6189 13.4218Z",
    fill: "#2B63A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9109 13.4218L11.3043 14.3493L14.5667 20L15.5031 17.9117L12.9109 13.4218Z",
    fill: "#2B63A6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9109 13.4218L14.5174 12.4943L17.7798 18.145L15.5031 17.9117L12.9109 13.4218Z",
    fill: "#418ED6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7623 15.0622C14.817 15.0622 17.2934 12.5858 17.2934 9.5311C17.2934 6.47636 14.817 4 11.7623 4C8.70756 4 6.2312 6.47636 6.2312 9.5311C6.2312 12.5858 8.70756 15.0622 11.7623 15.0622Z",
    fill: "#E3E3E3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7623 13.8485C14.1468 13.8485 16.0798 11.9155 16.0798 9.53101C16.0798 7.14651 14.1468 5.2135 11.7623 5.2135C9.37784 5.2135 7.44482 7.14651 7.44482 9.53101C7.44482 11.9155 9.37784 13.8485 11.7623 13.8485Z",
    fill: "#595959"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_97_5259",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 5,
    width: 10,
    height: 10
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9928 14.3195C14.3829 14.3195 16.3204 12.382 16.3204 9.99198C16.3204 7.60194 14.3829 5.66443 11.9928 5.66443C9.6028 5.66443 7.66528 7.60194 7.66528 9.99198C7.66528 12.382 9.6028 14.3195 11.9928 14.3195Z",
    fill: "#C28B37"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_97_5259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7624 13.8586C14.1524 13.8586 16.0899 11.9211 16.0899 9.53105C16.0899 7.141 14.1524 5.20349 11.7624 5.20349C9.37233 5.20349 7.43481 7.141 7.43481 9.53105C7.43481 11.9211 9.37233 13.8586 11.7624 13.8586Z",
    fill: "url(#paint0_linear_97_5259)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7857 6.52051L12.7192 8.38754L14.5862 8.62091L13.3042 10.0585L13.6527 12.1216L11.7857 11.1881L9.91862 12.1216L10.2702 10.0585L8.98511 8.62091L10.8522 8.38754L11.7857 6.52051Z",
    fill: "url(#paint1_linear_97_5259)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_97_5259",
    x1: 11.7624,
    y1: 5.2035,
    x2: 11.7624,
    y2: 13.8586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9CA1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9CA1A3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_97_5259",
    x1: 11.7857,
    y1: 6.52051,
    x2: 11.7857,
    y2: 12.1216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F5F5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_97_5259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverMedal);
export default __webpack_public_path__ + "static/media/silver-medal.3c63771d18a91c013d5a4cd5239facf7.svg";
export { ForwardRef as ReactComponent };